import { bl_cpcommerce_form_question_field_values_hdr_RowClass } from '../../dbschema/bl_cpcommerce_form_question_field_values_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class CpCommerceFormQuestionFieldValuesHdrContainerModel extends BaseContainerModel {
  bl_cpcommerce_form_question_field_values_hdr: bl_cpcommerce_form_question_field_values_hdr_RowClass = new bl_cpcommerce_form_question_field_values_hdr_RowClass();
}
